import { EpicIcons, TooltipPosition } from "@constellation-academy/epic-ui";
import { useState } from "react";
import { useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import type { deletePersonalizedNotificationTemplateButton_DeletePersonalizedNotificationTemplateMutation } from "@relay/deletePersonalizedNotificationTemplateButton_DeletePersonalizedNotificationTemplateMutation.graphql";
import { DELETE_PERSONALIZED_NOTIFICATION_TEMPLATE_MUTATION } from "./delete-personalized-notification-template-button.graphql";
import type { DeletePersonalizedNotificationTemplateButtonProps } from "./delete-personalized-notification-template-button.types";
import { Button, ButtonVariant } from "../../../../components/button";
import { ConfirmDialog } from "../../../../components/confirm-dialog";

export const DeletePersonalizedNotificationTemplateButton = ({
	personalizedNotificationTemplateId,
	connectionId,
	onDelete,
}: DeletePersonalizedNotificationTemplateButtonProps) => {
	const { t } = useTranslation("common");
	const [showDialog, setShowDialog] = useState(false);

	const [deletePersonalizedNotificationTemplate, isDeletingPersonalizedNotificationTemplate] =
		useMutation<deletePersonalizedNotificationTemplateButton_DeletePersonalizedNotificationTemplateMutation>(
			DELETE_PERSONALIZED_NOTIFICATION_TEMPLATE_MUTATION,
		);

	const handleOnDeleteClick = () => {
		setShowDialog(true);
	};

	const handleOnCancelConfirmDialog = () => {
		setShowDialog(false);
	};

	const handleOnDeleteConfirm = () => {
		deletePersonalizedNotificationTemplate({
			variables: {
				input: { id: personalizedNotificationTemplateId },
				connections: [connectionId],
			},
			onCompleted: () => {
				onDelete?.();
			},
		});
	};

	return (
		<>
			<ConfirmDialog
				title={t("personalizedNotificationTemplates.deleteTitle")}
				content={t("personalizedNotificationTemplates.deleteConfirm")}
				confirmButtonText={t("personalizedNotificationTemplates.deleteConfirmButton")}
				onConfirm={handleOnDeleteConfirm}
				onCancel={handleOnCancelConfirmDialog}
				showDialog={showDialog}
			/>
			<Button
				disabled={isDeletingPersonalizedNotificationTemplate}
				icon={EpicIcons.TRASH}
				variant={ButtonVariant.Error}
				onClick={handleOnDeleteClick}
				tooltip={t("personalizedNotificationTemplates.deleteTooltip")}
				position={TooltipPosition.Left}
			/>
		</>
	);
};
